export const CCLS_MODULE = '/cclsmodule/'
export const CCLS_MODULE_ALL = `${CCLS_MODULE}all`
export const CCLS_MODULE_TEACHER = `${CCLS_MODULE}teachers/`
export const CCLS_MODULE_UPLOAD_MATERIALS = `${CCLS_MODULE}upload-module-materials`
